import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "../api/axios";
import Header from "../Components/Header";
import BreadCrumb from "../Components/BreadCrumb";
import FilterPart from "../Layout/FilterPart";
import ProductList from "../Components/ProductList";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";

export default function ProductListing() {
  const [productCount, setProductCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [maxPrice, setMaxPrice] = useState(20000);
  const [sortBy, setSortBy] = useState("");

  const location = useLocation();

  // Fetch all categories on mount to build filters checklist and look up slugs
  useEffect(() => {
    axios.get('/categories?all=1')
      .then(response => {
        if (response.data && response.data.data) {
          setCategories(response.data.data);
        }
      })
      .catch(error => {
        console.error("Error fetching categories for listing page:", error);
      });
  }, []);

  // Sync category slug from URL parameter with selectedCategories checklist state
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categorySlug = searchParams.get('category');
    if (categorySlug && categories.length > 0) {
      let matched = categories.find(c => c.slug === categorySlug);
      if (!matched) {
        // Fallback partial matching
        const cleanSlug = categorySlug.replace(/s$/, '').toLowerCase();
        matched = categories.find(c => c.slug.toLowerCase().includes(cleanSlug));
      }
      if (matched) {
        setSelectedCategories([matched.id]);
      } else {
        setSelectedCategories([]);
      }
    } else if (!categorySlug) {
      setSelectedCategories([]);
    }
  }, [location.search, categories]);

  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get('search') || "";

  let activeCategory = null;
  let activeParentCategory = null;
  const categorySlug = searchParams.get('category');

  if (categorySlug && categories.length > 0) {
    activeCategory = categories.find(c => c.slug === categorySlug);
    if (!activeCategory) {
      const cleanSlug = categorySlug.replace(/s$/, '').toLowerCase();
      activeCategory = categories.find(c => c.slug.toLowerCase().includes(cleanSlug));
    }
    if (activeCategory && activeCategory.parent_id !== 0 && activeCategory.parent_id !== "0" && activeCategory.parent_id !== null) {
      activeParentCategory = categories.find(c => String(c.id) === String(activeCategory.parent_id));
    }
  }

  return (
    <div>
      <Header mode="dark" />
      <BreadCrumb 
        activeCategory={activeCategory} 
        activeParentCategory={activeParentCategory} 
        searchQuery={searchQuery}
      />
      <FilterPart 
        productCount={productCount} 
        categories={categories}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        maxPrice={maxPrice}
        setMaxPrice={setMaxPrice}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />
      <ProductList 
        setProductCount={setProductCount} 
        selectedCategories={selectedCategories}
        maxPrice={maxPrice}
        sortBy={sortBy}
        searchQuery={searchQuery}
      />
      <Feature />
      <Footer />
    </div>
  );
}
